import { AssignableRoles } from '@/api/assignableRoles/models/AssignableRoles';

export const sortAssignableRoles = (
  roles: AssignableRoles,
): AssignableRoles => {
  const roleOrder = [
    'ReadReports',
    'ReportsAdmin',
    'BoardDocumentsAdmin',
    'EditBoardDocuments',
    'ReadBoardDocuments',
  ];

  return (
    roles
      // Remove the unused ReadOrderHistory and PlaceOrder roles
      .filter((role) => role !== 'ReadOrderHistory' && role !== 'PlaceOrder')
      .sort((a, b) => {
        const indexA = roleOrder.indexOf(a);
        const indexB = roleOrder.indexOf(b);

        // Sort the roles based on their order in roleOrder
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        // If only one role exists in roleOrder, prioritize it
        if (indexA !== -1) {
          return -1;
        }
        if (indexB !== -1) {
          return 1;
        }

        // If neither role exists in roleOrder, sort alphabetically
        return a.localeCompare(b);
      })
  );
};
